"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductReviewStatus = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const gql_1 = require("../gql");
const hooks_1 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const useProductReviewStatus = () => {
    const { addError } = (0, hooks_1.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [setProductReviewStatus, { loading, error },] = (0, react_2.useMutation)(gql_1.SET_REVIEW_STATUS);
    const onSetProductReviewStatus = (0, react_1.useCallback)((args, options) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            const res = yield setProductReviewStatus({
                variables: {
                    productAttributeReview: args,
                    attribute: args.attribute,
                    attributeType: args.attributeType,
                },
            });
            // Check if the mutation response indicates failure
            if (!((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.productAttributeReview) === null || _b === void 0 ? void 0 : _b.success)) {
                throw new Error(t({ key: 'GENERAL_ERROR_MESSAGE' }));
            }
            return res;
        }
        catch (error) {
            if (!(options === null || options === void 0 ? void 0 : options.silent)) {
                addError(t({ key: 'GENERAL_ERROR_MESSAGE' }));
            }
            else {
                throw error;
            }
        }
    }), [addError, setProductReviewStatus, t]);
    return {
        onSetProductReviewStatus,
        loading,
        error,
    };
};
exports.useProductReviewStatus = useProductReviewStatus;
